<template>
  <div class="paid">
    <div class="paid-header">
      <div class="paid-header-dw">
        <div class="paid-header-tit">付费资讯中心</div>
        <div class="paid-header-search">
          <input type="text" placeholder="请输入搜索内容">
          <button>搜索</button>
        </div>
      </div>
    </div>
    <div class="paid-center">
      <div>
        <h4>付费资讯</h4>
      </div>
      <div class="paid-center-right">
        <router-link to="/paid-information">付费资讯 > {{titArray[titIndex]}}</router-link>
        <div class="paid-center-bg">您还不是会员，请<router-link to="/register" class="register">注册</router-link>会员。</div>
        <router-link :to="`/paid-information-title?id=${topIndex}`">上一篇：【付费资讯】{{titArray[topIndex]}}</router-link><br>
        <router-link :to="`/paid-information-title?id=${boottomIndex}`">下一篇：【付费资讯】{{titArray[boottomIndex]}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titIndex: "",
      topIndex: "",
      boottomIndex: "",
      titArray: [
        "下沉市场不需要巨头，但很需要社区团购",
        "中国制造网“三月采购节”启动 推出直播带货等活动",
        "两会后电商新时代！透露出哪些新经济趋势？",
        "2021年中国互联网发展趋势",
        "2021年互联网行业展望：全面拥抱数字时代",
        "5G技术能为智能制造赋能哪些？",
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
  mounted() {
    this.titIndex = Number(this.$route.query.id);
    let topIndex = this.titIndex - 1,
      boottomIndex = this.titIndex + 1;
    this.topIndex = topIndex < 0 ? 5 : topIndex;
    this.boottomIndex = boottomIndex > 5 ? 0 : boottomIndex;
  },
};
</script>
<style scoped>
.paid-header {
  width: 100%;
  height: 100px;
  background: url(../../assets/images/pian-background.jpg);
  background-size: 100% 100%;
}
.paid-header-dw,
.paid-center {
  margin: 0 auto;
  width: 1200px;
  display: flex;
}
.paid-header-dw div {
  flex-direction: row;
  flex-wrap: wrap;
}
.paid-header-tit {
  width: 300px;
  font-size: 30px;
  line-height: 100px;
  color: #fff;
}
.paid-header-search {
  width: 800px;
  line-height: 100px;
}
.paid-header-search input {
  height: 32px;
  width: 500px;
  border: none;
  border-radius: 20px 0 0 20px;
  padding: 6px 20px;
  font-size: 14px;
  font-weight: 100;
  color: #555;
}
.paid-header-search button {
  border: none;
  width: 100px;
  height: 44px;
  line-height: 44px;
  margin: -1px 0 0 -4px;
  border-radius: 0 20px 20px 0;
  cursor: pointer;
  background: #e4393c;
  font-size: 18px;
  font-weight: 100;
  color: #fff;
  vertical-align: middle;
}
.paid-center {
  padding: 40px 0 100px 0;
}
.paid-center div {
  flex-direction: row;
  flex-wrap: wrap;
}
.paid-center div h4 {
  display: inline-block;
  width: 200px;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  text-align: center;
  background: #333333;
  color: #fff;
}
.paid-center-right {
  width: 800px;
  margin: 10px 40px;
  font-size: 18px;
  color: #555;
}
.paid-center-right .paid-center-bg {
  margin: 80px 0 40px 140px;
  width: 400px;
  height: 200px;
  color: #f00;
  /* background: url(./../../../static/收款码勿删.png); */
  background-size: 100% 100%;
}
.register {
  color: rgb(83, 160, 190);
  margin: 0 6px;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// paid-title.vue?406194ec